var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.mfaEnrollmentBox},[_c('i',{class:[_vm.$style.mfaEnrollmentIcon, 'jc-mfa-pending']}),_c('span',[_vm._v("Apply an enrollment period of")]),_c('div',{class:_vm.$style.inputContainer},[_c('InputValidator',{class:{
        [_vm.$style.mfaEnrollmentInput]: true,
        [_vm.$style.mfaEnrollmentInputWithError]: _vm.v2Errors.items.length,
      },attrs:{"config":{
        errorStyleExceptions: _vm.$style.validationError,
        name: 'MFA Enrollment Period',
        validate: 'required|numeric|min_value:1|max_value:365',
        value: _vm.value,
      }},on:{"InputValidatorModel":_vm.handleValueChange}})],1),_c('span',[_vm._v("days for "+_vm._s(_vm.keyword)+".")])])
}
var staticRenderFns = []

export { render, staticRenderFns }